/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_map.js                                                                               */
/**********************************************************************************************************************/
/* Controller.Map */
HafasWebapp.prototype.Controller.Map = {

  instance: null, // will be initialized onload
  selectionMap: null,
  connectionMaps: [],
  markerSEARCH: null,
  markerSTART: null,
  markerDEST: null,
  favoriteMarkers: {},
  reverseLookUpTimeout: null,
  searchMode: 'line',
  locGraphMapContent: [],
  stbLocContainer: [],
  LineSearchCommonArr: null,
  LineSearchLineLArr: null,
  processedLineD: null,
  statOnTime: null,
  currentDragRequestCounter: 0,
  productName: null,
  dragHint: null,
  connectionMaps: [],   // holds references to created maps in connection details (formbased planner)
  weather:{
    refreshTimeoutReference: null,    // holds a reference to a window.setTimeout Call for a refreshing weather request
    currentMapCenter: null   // holds the current map center of the last weather request
  },
  initialView: null,
  updateOffset: function () {
    var mapInstance;
    if (this.main) {
      mapInstance = this.main.Controller.Map.instance;
    }
    if (!this.main) {
      mapInstance = this.Controller.Map.instance;
    }

    var yPadding = Hafas.Config.Maps.offsetTop;

    // Map functions for md, lg, xlg
    if (this.mq == 'md' || this.mq == 'lg' || this.mq == 'xlg') {
      var xPadding;

      switch (this.mq) {
        case 'xlg':
          xPadding = 650;
          break;
        case 'lg':
          xPadding = 650;
          break;
        case 'md':
          xPadding = 332;
          break;
      }
      mapInstance.setOffset({x: xPadding, y: yPadding});
    }
    else {
      // padding von 0 für smartView (50 = Höhe des Headers muss berücksichtigt werden)
      mapInstance.setOffset({x: 0, y: 50});
    }
  },
  /**
   * saves the initial map view
   * @param {object} webapp map instance
   *
   * @method saveInitialMapView
   */
  saveInitialMapView: function(map){
    this.Controller.Map.initialView = {
      center: map.getCenter(),
      zoom: map.getZoom("api"),
    }
  },
  /**
   * restores the initial map view
   *
   * @method restoreInitialMapView
   */
  restoreInitialMapView: function(){
    var map = this.Controller.Map.instance;
    var initialView = this.Controller.Map.initialView;
    if(this.Controller.Map.initialView && map) {
      map.centerToGeo(this.Controller.Map.initialView.center)
      map.setZoom(this.Controller.Map.initialView.zoom, "api");
    }
  },
  toggleSearchMode: function (mode) {
    Hafas('[data-search="line"]').removeClassName('hidden');
  },
  toolbox: {
    stationsNearList: [],
    stationsnear: {
      getStations: function (data) {
        // +++ /map/toolbox/stationsnear/getStations +++
        var _me = this;

        var mapController = _me.Controller.Map;
        var mapInstance = mapController.instance;

        // clear stationsnear, if existing
        for (var l = 0; l < mapController.toolbox.stationsNearList.length; l++) {
          var mrk = mapController.toolbox.stationsNearList[l];
        }
        mapController.toolbox.stationsNearList = [];

        var requestObj = {
          ring: {
            cCrd: {
              y: parseInt(data.location.crd.y),
              x: parseInt(data.location.crd.x)
            },
            maxDist: Hafas.Config.Maps.toolbox.stationsNearRadius
          },
          getPOIs: false,
          getStops: true,
          maxLoc: 5
        };

        Hafas.Core.newType('hafasRequest', {
          request: "LocGeoPos",
          requestType: "hci",
          requestobj: requestObj,
          loadingModule: "LocGeoPos",
          callback: function (res) {
            mapController.toolbox.stationsnear.showResult(res, _me);
          }
        });
      },
      showResult: function (result, _me) {
        var mapController = _me.Controller.Map;
        var mapInstance = mapInstance = mapController.instance;

        if (!mapInstance) {
          return;
        }

        for (var l = 0; l < result.svcResL[0].res.locL.length; l++) {
          var tmpMarker = Hafas.Util.maps.showHCILocation(result.svcResL[0].res.locL[l], mapInstance, null, false, {selectable: true});
          _me.Controller.Map.toolbox.stationsNearList.push(tmpMarker);
        }
      }
    }
  },
  clearSearchMarker: function () {
    if (this.markerSEARCH != null) {
      this.instance.hideContent(this.markerSEARCH);
      this.instance.removeContent(this.markerSEARCH);
    }
  },
  updateSize: function () {

    var mapInstance;
    if (this.main) {
      mapInstance = this.main.Controller.Map.instance;
    }
    if (!this.main && typeof this.Controller != 'undefined') {
      mapInstance = this.Controller.Map.instance;
    }
    if (mapInstance != null) {
      mapInstance.updateSize();
    }
  },
  openMapViewer: function (opts) {

    // switch this-context
    var _me = this;

    // get MapContainer as HTML-Element
    var $mapView = Hafas('#' + _me.mapContainer, false);
    var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);

    $mapView.style.top = 0;
    $mapView.style.left = 0;
    $mapView.style.zIndex = 1000000;
    $mapView.style.height = window.innerHeight - 1 + 'px';
    $mapView.addClassName('js_singleViewMode');

    $mapViewHeader.removeAttribute('hidden');

    // render map Header
    Hafas.Modules.Render.render({
      file: 'common.map.html',
      target: 'HFS_PageMapHeader',
      template: 'Common_Map_SingleViewModeHeader',
      model: {}
    }, function () {
      _me.Controller.Map.updateSize();
      _me.Controller.Map.updateOffset();
    });
  },
  closeMapViewer: function (opts) {
    // switch this-context
    var _me = this;

    // get MapContainer as HTML-Element
    var $mapView = Hafas('#' + _me.mapContainer, false);
    var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);

    // reset Styles
    $mapView.removeAttribute('style');
    $mapView.removeClassName('js_singleViewMode');

    $mapViewHeader.hidden = true;

    Hafas.ps.pub('/app/events/resize');
  },
  showGraph: function (data) {
    if (typeof data.type == 'undefined' || data.type === 'JourneyGraph') {
      var reqObj = Hafas.Core.newType('hafasHCIRequestObject', 'JourneyGraph', {});
      var requestName = 'JourneyGraph';
    } else if (data.type === 'LocGraph') {
      var reqObj = Hafas.Core.newType('hafasHCIRequestObject', 'LocGraph', {});
      var requestName = 'LocGraph';
    }

    for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
      Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g], this.Controller.Map.instance, true);
    }

    if (data.pid) {
      reqObj.add('req.jnyFltrL');
      reqObj.add('req.jnyFltrL.type', 'PID');
      reqObj.add('req.jnyFltrL.mode', 'INC');
      reqObj.add('req.jnyFltrL.value', data.pid);
    }
    if (data.jid) {
      reqObj.add('req.jnyFltrL');
      reqObj.add('req.jnyFltrL.type', 'JID');
      reqObj.add('req.jnyFltrL.mode', 'INC');
      reqObj.add('req.jnyFltrL.value', data.jid);
    }

    if (typeof data.locL != 'undefined') {
      for (var d = 0; d < data.locL.length; d++) {
        reqObj.add('req.locL');
        reqObj.add('req.locL.lid', data.locL[d]);
        if(data.locL[d].crd && data.locL[d].type === 'C') {
          reqObj.add('req.locL.crd.x', data.locL[d].crd.x);
          reqObj.add('req.locL.crd.y', data.locL[d].crd.y);
          reqObj.add('req.locL.type', data.locL[d].type);
        }
        reqObj.add('req.type', 'RT_GRAPH');
      }
    }


    if (typeof data.toggleMode == 'undefined') {
      var centerToResult = true;
    } else {
      var centerToResult = false;
    }

    var hciRequest = Hafas.Core.newType('hafasHCIRequest', {requests: [reqObj]});

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');

    Hafas.Core.newType("hafasRequest", {
      request: requestName,
      requestType: "hci",
      hciRequestObj: hciRequest,
      callback: Hafas.bind(function (data) {
        if (data.status.error == false) {
          var mapContent = Hafas.Util.maps.showGraph(this.Controller.Map.instance, data);
          this.Controller.Map.locGraphMapContent.push(mapContent);
          if (typeof mapContent.polylines != 'undefined' && centerToResult) {
            this.Controller.Map.instance.centerToContent(mapContent.polylines)
          }
        }
      }, this)
    });
  },
  openMapViewerForDetails: function (opts) {
    // switch this-context
    var _me = this;

    if (this.layoutClass == "small") {
      // get MapContainer as HTML-Element
      var $mapView = Hafas('#' + _me.mapContainer, false);
      var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);
      $mapViewHeader.innerHTML = "";

      this.Controller.Map.updateSize();
    }

    this.Controller.Map.connection.centerRoute();
  },
  selectLocation: function (map, loc, common, markerParams, options, focus) {
    map.removeAllToolboxItems();
    if (typeof this.Controller.SQ.additionalInstances != 'undefined') {
      this.Controller.SQ.additionalInstances = {};
    }

    if (typeof markerParams != 'undefined') {
      var markerReference = markerParams.cc;
    } else {
      var markerReference = null;
    }
    options = options || {};

    // Marker-Referenz muss zwingend auch in den Options übergeben werden,
    // da sonst der Parameter bei dynamischen erzeugten Flyout-Typen nicht greift
    if(markerReference !== undefined){
      options.markerRef = markerReference;
    }
    // useAddFavorite Flag muss zwingend auch in den Options übergeben werden,
    // da sonst der Parameter bei dynamischen erzeugten Flyout-Typen nicht greift
    if (Hafas.Config.Maps.toolbox.useAddFavorite === true) {
      options.useAddFavorite = true;
    }

    if (common == undefined)
      common = null;
    var toolboxParams = {location: loc, common: common, markerRef: markerReference};
    if(typeof options != 'undefined'){
      toolboxParams.options = options;
    }
    try {
      Hafas.Modules.Maps.getToolbox(toolboxParams).show(map, focus);
      this.Controller.Map.instance.currentLocation = toolboxParams.location;
    } catch (e) {
      Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, 'map.selectLocation', 'Error creating flyout', e);
    }
  },
  /**
   * Open popover on A/B buttons where the user can select which feature to paste the location into.
   * @method openPopoverSelection
   * @param {String} type - 'dep' or 'arr', to place the popover at the correct button
   * @param {String} locKey - the key to get the location from the object keeper
   */
  openPopoverSelection: function(type, locKey) {

    var _me = this;
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    var triggerElem = document.querySelector('.lyr_flyoutActionbutton_' + type);

    var model = {
      loc: location
    };
    model.popoverCloseEvent = '/map/closeLocationPopover';
    model.isAddress = false;
    model.locKey = locKey;
    model.type = type;

    if (location.type === 'A') {
      model.isAddress = true;

      var activeWebappContext = Hafas.getWebAppContext();
      var tariffContextActive = (activeWebappContext == 'TariffWizard' || activeWebappContext == 'TariffSearch');

      if (tariffContextActive && activeWebappContext) {
        model.textLabel = "Flyout.t_N_addressWarning" + activeWebappContext;
      }
    }

    _me.Controller.Map.locationSelectPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerElem.parentNode,
      anchoredOverlay: 'DESKTOP',
      triggerElement: triggerElem,
      outputHTML: Hafas.Modules.Render.renderTemplate("Common_Flyout_PopoverContent", model),
      cssClass: 'lyr_locationSelectPopover',
      centerArrow: true,
      callback: function (html, err) {

        //disable tariff-buttons if location is not a station
        if (location.type !== 'S') {
          var popoverButtons = document.querySelectorAll('.lyr_popoverButtonRow>.lyr_atomBtn');
          for (var button = popoverButtons.length - 1; button > 0; button--) {
            popoverButtons[button].disabled = true;
          }
        }
      }
    });
  },

  /**
   * Method to close the Flyout-Popover.
   * @method closeLocationPopover
   */
  closeLocationPopover: function() {
    var _me = this;
    if(_me.Controller.Map.locationSelectPopover){
      _me.Controller.Map.locationSelectPopover.close(null);
      _me.Controller.Map.locationSelectPopover = null;
    }
  },

  /**
   * Method closes flyout and flyout popover, sets the location in the tripplanner instance and switches context.
   * @method setTPfromPopover
   * @param {String} type - 'dep' or 'arr', to set the correct type of location
   * @param {String} locKey - the key to get the location from the object keeper
   */
  setTPfromPopover: function(type, locKey) {
    Hafas.ps.pub('/map/closeToolbox', [{}]);
    Hafas.ps.pub('/map/closeLocationPopover');
    var loc = Hafas.Modules.Render.objectKeeper.get(locKey);

    // call setViaFromExternal when setting a via from map flyout (e.g. in TariffWizard)
    if (type === "via") {
      Hafas.ps.pub('/tp/setViaFromExternal',['via', locKey]);
    } else {
      this.Controller.TP.instance.setLocation(type, loc);
    }
  },
  /**
   * Method closes flyout and flyout popover, sets the location in the tariffsearch instance and switches context.
   * @method setTPfromPopover
   * @param {String} type - 'dep' or 'arr', to set the correct type of location
   * @param {String} locKey - the key to get the location from the object keeper
   */
  setTSfromPopover: function(type, locKey) {
    Hafas.ps.pub('/map/closeToolbox', [{}]);
    Hafas.ps.pub('/map/closeLocationPopover');
    var loc = Hafas.Modules.Render.objectKeeper.get(locKey);

    this.Controller.TariffSearch.instance.setLocation(type, loc);
    Hafas.ps.pub('/app/switchContext', [{trigger: this, context: 'TariffSearch', method: 'index'}]);
  },

  /**
   * Method closes flyout and flyout popover, sets the location in the tariffwizard instance and switches context.
   * @method setTPfromPopover
   * @param {String} type - 'dep' or 'arr', to set the correct type of location
   * @param {String} locKey - the key to get the location from the object keeper
   */
  setTWfromPopover: function(type, locKey) {
    Hafas.ps.pub('/map/closeToolbox', [{}]);
    Hafas.ps.pub('/map/closeLocationPopover');
    var loc = Hafas.Modules.Render.objectKeeper.get(locKey);

    this.Controller.TariffWizard.instance.setLocation(type, loc);
    Hafas.ps.pub('/app/switchContext', [{trigger: this, context: 'TariffWizard', method: 'index'}]);
  },

  getLocation:function (){

  },

  getLocDetails: function (locData) {
    var requestTimeStamp = new Date().getTime();
    Hafas.Util.location.getLocDetails(locData, Hafas.bind(function(locDetailsResult,requestData){
      var responseTimeStamp = new Date().getTime()
      var deltaRequestResponse = responseTimeStamp - requestTimeStamp;
      // Ladegrafik mindestens 250 ms anzeigen
      var timeout = Math.max(250 - deltaRequestResponse,0);
      if (typeof locDetailsResult.status.error == 'undefined' || locDetailsResult.status.error == false) {
        if (locDetailsResult.svcResL.length > 0 && locDetailsResult.svcResL[0].res.locL.length > 0) {
          var loc = locDetailsResult.svcResL[0].res.locL[0];
          Hafas.Core.newType("hafasMessages", {
            result: locDetailsResult.svcResL[0].res,
            type: 'map'
          });
          this.Controller.Map.mobilityRadar.saveLocDetails(requestData.extId,loc);
          window.setTimeout(Hafas.bind(function() {
            Hafas.bind(this.Controller.Map.renderLocDetails,this)(requestData.extId, loc);
          },this),timeout);
        }
      }
    },this),{
      'req.zoom': this.Controller.Map.instance.getZoom("api")
    });
  },
  renderLocDetails: function (extId, location) {
    var linesTargetContainer = Hafas('[data-toolbox-lines="lines_' + extId + '"]', false);
    if (location && linesTargetContainer) {
      var model = {
        location: location
      };
      Hafas.Modules.Render.render({
        file: 'common.map.html',
        target: linesTargetContainer,
        template: 'Common_Map_Lines',
        model: model
      }, Hafas.bind(function (htmlRendered) {

      }));
    }

    // Render Flyout Details after LocDetails Request
    var mcpTarget = Hafas('#HFS_FlyoutDetails', false);
    if(location.mcpData !== undefined && location.dataList !== undefined) {
      var template = Hafas.Util.location.getMCPTemplate(location);
      Hafas.Util.gui.setVisibility(mcpTarget, true);
      Hafas.Modules.Render.render({
        file: 'common.map.html',
        target: mcpTarget,
        template: template,
        model: location.dataList
      }, function (html) {

      });
    }else if((location.mapDtlCntStyleTemplate !== undefined) && (location.mapDtlCntStyleTemplate.tpl !== undefined)){
      var tplToUse = "Common_Flyout_" + location.mapDtlCntStyleTemplate.tpl;
      if(typeof(location.mapDtlCntStyleTemplate) != "undefined" && (typeof(location.mapDtlCntStyleTemplate.dspMode) != "undefined") && ((location.mapDtlCntStyleTemplate.dspMode == "COL") || (location.mapDtlCntStyleTemplate.dspMode =="HIDE")))
        Hafas.Util.gui.setVisibility(mcpTarget, false);
      Hafas.Modules.Render.render({
        file: 'common.map.html',
        target: mcpTarget,
        template: tplToUse,
        model: location
      }, function () {
        Hafas.Util.location.refreshDynamicFlyoutContent(location);
      });
    }

    var flyoutMsgs = Hafas('#HFS_FlyoutMessagesInner');
    if(flyoutMsgs){
      Hafas.Modules.Render.render({
        file: 'map.flyout.html',
        target: flyoutMsgs,
        template: 'Common_Flyout_InnerMessages',
        model: location
      }, function (messagesRendered) {

      }.bind(this))
    }
    this.Controller.Map.renderExternalContentButtons(location);
  },
  /**
   * Render external content buttons in the map flyout if data is available.
   * @param {object} location - The location whose external content should be rendered
   */
  renderExternalContentButtons: function (location) {
    if (location.trfRes) {
      // Render external content action button
      if (location.trfRes.extContActionBar) {
        var extContActionBar = location.trfRes.extContActionBar;

        if (extContActionBar && extContActionBar.content && extContActionBar.content.type && Hafas.Config.Tariffs.supportedExtContTypes.includes(extContActionBar.content.type) === false) {
          // external content type not supported, show nothing
          console.warn("External Content Type '" + extContActionBar.content.type + "' not supported.");
          return;
        }

        var extContActionButton = Hafas('#HFS_FlyoutExtContActionButton');
        if (extContActionButton) {
          var onclick = "Hafas.ps.pub('/common/openExternalLink', ['" + extContActionBar.content.contentResolved + "']);"
          if (Hafas.Config.Switches.useTerminalMode) {
            onclick = "Hafas.ps.pub('/GUI/showQrCodeOverlay',[{url:'" + extContActionBar.content.contentResolved + "',title:'" + (extContActionBar.textS || '') + "',description:'" + (extContActionBar.text || '') + "',trigger:this,anchor:this,centerArrow:true,forcePlacement:'above'}])";
          }
          Hafas.Modules.Render.render({
            file: 'common.buttons.html',
            target: extContActionButton,
            template: 'Common_AtomTplFlyoutButton',
            model: {
              content: [
                {
                  className: 'lyr_icoFlyout',
                  icnClass: extContActionBar.icoResolved.icnClass,
                  text: extContActionBar.text
                },
              ],
              onclick: onclick
            }
          });
          // Container is initially hidden, so it does not take up space and cannot be found by screenreaders if empty
          Hafas.Util.gui.setVisibility(extContActionButton, true);
        }
      }
      // Render text-only external content button
      if (location.trfRes.extCont) {
        var extCont = location.trfRes.extCont;

        if (extCont && extCont.content && extCont.content.type && Hafas.Config.Tariffs.supportedExtContTypes.includes(extCont.content.type) === false) {
          // external content type not supported, show nothing
          console.warn("External Content Type '" + extCont.content.type + "' not supported.");
          return;
        }

        var extContWrapper = Hafas('#HFS_FlyoutExtContWrapper');
        if (extContWrapper) {
          var onclick = "Hafas.ps.pub('/common/openExternalLink', ['" + extCont.content.contentResolved + "']);"
          if (Hafas.Config.Switches.useTerminalMode) {
            onclick = "Hafas.ps.pub('/GUI/showQrCodeOverlay',[{url:'" + extCont.content.contentResolved + "',title:'" + (extCont.textS || '') + "',description:'" + (extCont.text || '') + "'}])";
          }
          Hafas.Modules.Render.render({
            file: 'common.buttons.html',
            target: extContWrapper,
            template: 'Common_AtomTplPrimaryButton',
            model: {
              id: 'HFS_FlyoutExtContButton',
              onclick: onclick,
              content: {
                text: extCont.text
              }
            }
          });
          // Container is initially hidden, so it does not take up space and cannot be found by screenreaders if empty
          Hafas.Util.gui.setVisibility(extContWrapper, true);
        }
      }
    }
  },
  toggleFlyoutDetails: function(show, data) {
    var flyoutDetails = Hafas('#HFS_FlyoutDetails');
    var cState = flyoutDetails.hidden;
    Hafas.Util.gui.setVisibility(flyoutDetails, cState);
    data.trigger.setAttribute("aria-expanded", cState);

  },
  closeToolbox: function () {
    if (this.Controller.Map.instance) {
      this.Controller.Map.instance.removeToolboxItem('mapSelection', 'id');
    }
    if (this.Controller.Map.selectionMap) {
      this.Controller.Map.selectionMap.removeToolboxItem('mapSelection', 'id');
    }
    if (typeof this.Controller.Map.locGraphMapContent != 'undefined') {
      for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
        Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g], this.Controller.Map.instance, true);
      }
    }
  },
  closeToolboxItem: function (map, toolboxData) {

    var toolboxId = null;
    if (toolboxData != undefined)
      toolboxId = toolboxData.id;

    if (this.Controller.Map.instance) {
      this.Controller.Map.instance.removeToolboxItem(toolboxId, 'id');
    }
    if (this.Controller.Map.selectionMap) {
      this.Controller.Map.selectionMap.removeToolboxItem(toolboxId, 'id');
    }
  },
  closeAllToolboxItems: function () {
    this.Controller.Map.instance.removeAllToolboxItems();
  },
  /**
   * If a location marker is shown only because a corresponding flyout is open, remove it.
   */
  removeFlyoutLocationMarker: function () {
    var markerRef = this.Controller.Map.flyoutLocationMarker;
    if (markerRef != null) {
      this.Controller.Map.instance.hideContent(markerRef);
      this.Controller.Map.instance.removeContent(markerRef);
      delete this.Controller.Map.flyoutLocationMarker;
    }
  },
  setLocation: function (locObj) {
    var coord = Hafas.Util.geo.hciCrdToHafasCoord(locObj.crd);
    this.Controller.Map.instance.centerToGeo(coord);
    this.Controller.Map.instance.setZoom(Hafas.Config.Maps.searchPredefinedZoom, "api");
    Hafas('#MapLocation', false).value = locObj.name;
  },

  // karte auf koordinate zentrieren und ggf. auch zoomstufe setzen
  centerToGeo: function (data) {

    this.Controller.Map.instance.centerToGeo(data.coord, data.zoom);
  },

  // zoomstufe setzen
  setZoom: function (zoom) {
    this.Controller.Map.instance.setZoom(zoom, 'api');
  },

  enablGestureHandling: function(bool) {
    this.Controller.Map.instance.enablGestureHandling(bool);
  },

  centerCurrentRoute: function (opts) {
    if(opts.type === undefined || opts.type == 'centerRoute') {
      if (typeof this.Controller.Map.connection != 'undefined') {
        this.Controller.Map.connection.centerRoute();
      }
    }
  },
  setLocationMarker: function (type, location,addData) {
    if (!location) {
      console.warn('No location set!!!');
      return;
    }
    if(!location.crd)  {
      console.warn('No location coordinates set!!!');
      return;
    }

    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;

    if (!mapInstance) {
      return;
    }

    var crd = Hafas.Core.newType("hafasCCoord", {lon: location.crd.x, lat: location.crd.y});

    switch (type) {
      case 'dep':
        var markerTmpl = 'START';
        break;
      case 'arr':
        var markerTmpl = 'DEST';
        break;
      case 'via':
        var markerTmpl = 'VIA';
        break;
    }

    var markerCfg = Hafas.Config.Maps.Marker;
    var params = {
      type: 'location',
      data: {
        type: type
      },
      coord: crd,
      imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
      imagewidth: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
      imageheight: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
      hotspot: {
        x: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
        y: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
      },
      priority: 10000,
      draggable: Hafas.Config.Maps.enableDragAndDrop,
      text: location.name,
      onDrag: function (coord, marker, map) {

      },
      onclick: function (hciLoc) {
        return function () {
          Hafas.ps.pub('/map/clickOnLocation', [mapInstance, hciLoc]);
          if (Hafas.Config.Maps.toolbox.showLines == true && hciLoc.type == 'S' && typeof common == 'undefined') {
            Hafas.ps.pub('/map/clickOnLocation/getLocDetails', [hciLoc]);
          }
        };
      }(location)
    };

    if (type != 'via') {
      params.draggable = Hafas.Config.Maps.enableDragAndDrop;
    } else {
      params.draggable = false;
    }


    var markerId = "marker" + markerTmpl;
    if(addData !== undefined && addData.index !== undefined){
      markerId += "_" + addData.index;
    }
    // Vorherigen Marker ggfs. löschen
    if (mapController[markerId] != null) {
      mapInstance.hideContent(mapController[markerId]);
      mapInstance.removeContent(mapController[markerId]);
    }
    mapController[markerId] = mapInstance.createContent(params);
    mapInstance.showContent(mapController[markerId]);
    mapController.updateSelectionView(crd);
  },
  clearLocationMarker: function (type,addData) {
    var markerTmpl = type;
    switch (type) {
      case 'dep':
        markerTmpl = 'START';
        break;
      case 'arr':
        markerTmpl = 'DEST';
        break;
      case 'via':
        markerTmpl = 'VIA';
        break;
    }

    var mapController = this.Controller.Map;

    var markerId = "marker" + markerTmpl;
    if(addData !== undefined && addData.index !== undefined){
       markerId += "_" + addData.index;
    }
    this.Controller.Map.deleteMapMarkerById.bind(this)(markerId);
  },
  deleteMapMarkerById: function(markerId){
    var mapController = this.Controller.Map;
    if (typeof mapController[markerId] != 'undefined' && mapController[markerId] != null) {
      mapController.instance.hideContent(mapController[markerId]);
      mapController.instance.removeContent(mapController[markerId]);
      mapController[markerId] = null;
    }
  },
  // löscht alle aktuellen Via Marker von der Karte
  clearAllViaMarker: function(){
    var currentViaList = this.Controller.TP.instance.getViaList();
    for(var v=0; v < currentViaList.length;v++){
      this.Controller.Map.deleteMapMarkerById.bind(this)('markerVIA_' + v);
    }
  },
  // blendet alle aktuellen Via Marker aus
  hideAllViaMarker: function(){
    var viaMarkerIndex = 0;
    var viaMarkerID = this.Controller.Map["markerVIA_" + viaMarkerIndex];
    while (typeof viaMarkerID !== 'undefined' && viaMarkerIndex < 100) {
      this.Controller.Map.instance.hideContent(viaMarkerID);
      viaMarkerID = this.Controller.Map["markerVIA_" + ++viaMarkerIndex];
    }
    // var currentViaList = this.Controller.TP.instance.getViaList();
    // for(var v=0; v < currentViaList.length;v++){
    //   if(this.Controller.Map["markerVIA_" + v] !== undefined) {
    //     this.Controller.Map.instance.hideContent(this.Controller.Map["markerVIA_" + v]);
    //   }
    // }
  },
  /* löscht alle Map Marker A,B und Vias von der Karte */
  clearAllMapMarker: function(){
    this.Controller.Map.deleteMapMarkerById.bind(this)("markerSTART");
    this.Controller.Map.deleteMapMarkerById.bind(this)("markerDEST");
    this.Controller.Map.clearAllViaMarker.bind(this)();
  },
  /**
   * Create a favorite marker for a location and put it on the map.
   * @param {Object} location - The location being added as a favorite
   * @param {Object} [options] - Further instructions for creating the marker
   * @param {boolean} [options.forceRedraw] - If true, location marker will be redrawn instead of skipped if it already exists
   * @param {boolean} [options.useFallbackParams] - If true, location marker will be drawn as product icon with fallback size
   * @param {boolean} [options.ignoreMainMast] - Only relevant for submasts. If true, the markers for the main mast and other submasts will not be added
   */
  createFavoriteMarker: function (location, options) {
    if (!Hafas.Config.Switches.useFavorites) {
      return;
    }

    var forceRedraw = options && options.forceRedraw || false;
    var useFallbackParams = options && options.useFallbackParams || false;
    var ignoreMainMast = options && options.ignoreMainMast || false;
    var isSmartLocationWithProd = false;
    var isTemp = false;

    var mapController = this.Controller.Map;

    if (location.mMastLocResolved && !ignoreMainMast) {
      // If location references a main mast, add favorite marker for the main mast
      // The marker for the current location and all other submasts of the main mast will be added recursively
      Hafas.ps.pub('/map/createFavoriteMarker', [location.mMastLocResolved, {forceRedraw: true}]);
      return;
    }

    // Get location data currently stored in mobilityRadar
    var locationData = mapController.mobilityRadar ? mapController.mobilityRadar.locationData : {};

    // Check if the current location is selected on the map
    var isSelected = mapController.mobilityRadar?.isLocationSelected(location);

    if (location.isMainMast) {
      // If location is flagged as a main mast, find locations that reference it
      var submasts = Object.values(locationData).filter(loc => loc.location.mMastLocResolved && loc.location.mMastLocResolved.extId === location.extId);
      if (submasts.length) {
        // Redraw submasts as favorites
        submasts.forEach(loc => {
          Hafas.ps.pub('/map/createFavoriteMarker', [loc.location, {forceRedraw: true, ignoreMainMast: true}]); // ignoreMainMast to avoid infinite loops
        });
        // If a favorite is a main mast whose submasts appear in the location list from the server,
        // the marker should be drawn only if the main mast itself also appears in the list or is currently selected
        if (!locationData[location.extId]) {
          if (isSelected) {
            isTemp = true; // remove marker when flyout is closed
          } else {
            Hafas.ps.pub('/map/removeFavoriteMarker', [location, {ignoreSubMasts: true}]);
            return;
          }
        }
      }
    }

    if (!location) {
      console.warn('No location set!!!');
      return;
    }

    var mapInstance;
    if (Hafas.Config.layoutMode === '_classic') {
      mapInstance = mapController.selectionMap;
    } else {
      mapInstance = mapController.instance;
    }

    if (!mapInstance) {
      return;
    }

    // If location is a smart location, always show it in the default size
    Hafas.Util.getSmartLocationInfo(location);
    if (location.smartLocation && location.smartLocation.prod) {
      // If no icon was selected for the smart location, treat it as a regular favorite
      useFallbackParams = true;
      isSmartLocationWithProd = true;
    }

    // Create coordinates
    if (location.crd) {
      var lon = location.crd.x;
      var lat = location.crd.y;
      var crd = Hafas.Core.newType("hafasCCoord", {lon: lon, lat: lat});
      if (lon.length === 0 && lat.length === 0) {
        return;
      }
    } else {
      return;
    }

    // Create container ID
    var locIdentifier = location.extId;
    var markerTmpl = "FAV_" + locIdentifier;
    var markerId = "marker" + markerTmpl;

    // If marker already exists (e.g. when updating favorites), do nothing
    if (mapController.favoriteMarkers[markerId] != null && forceRedraw !== true) {
      return;
    } else if (mapController.favoriteMarkers[markerId] != null) {
      mapInstance.hideContent(mapController.favoriteMarkers[markerId]);
      mapInstance.removeContent(mapController.favoriteMarkers[markerId]);
    }

    // Store original, non-favorite marker for later use
    var nonFavoriteMarkerRef = mapController.mobilityRadar.getContentReference(location.extId);
    var nonFavoriteContent = mapInstance.getContent(nonFavoriteMarkerRef);

    var FALLBACK_ICON_SIZE = Hafas.Config.Maps.Marker.FALLBACK_ICON_SIZE;

    var newMarkerParams = {
      coord: crd,
      text: location.name + ', ' + Hafas.Modules.i18n.get('Map.a11y.t_N_Favorite'),
      draggable: false
    };
    if (isSmartLocationWithProd) {
      newMarkerParams.type = 'location';
      newMarkerParams.className = 'lyr_mapSmartLocation';
      newMarkerParams.hotspot = {
        x: FALLBACK_ICON_SIZE / 2,
        y: FALLBACK_ICON_SIZE / 2
      };
    } else {
      newMarkerParams.type = 'container';
      newMarkerParams.className = 'lyr_mapFavoriteContainer';
      if (nonFavoriteContent && nonFavoriteContent.className) {
        newMarkerParams.className += ' ' + nonFavoriteContent.className;
      }
    }
    if (nonFavoriteContent && nonFavoriteContent.priority) {
      newMarkerParams.priority = nonFavoriteContent.priority;
    }

    var containerHtml = '';
    var favHtml = '';
    var starIconPath = Hafas.Config.imagePath + 'common/haf_map_fav.svg';

    if (!useFallbackParams && nonFavoriteContent && nonFavoriteContent.type === 'container') {
      // Use existing container HTML and just add a star to it
      containerHtml = nonFavoriteContent.html;
      favHtml = Hafas.Modules.Render.renderTemplate('Common_Map_IconMarker', {imageUrl: starIconPath, className: 'lyr_mapFavStar'});
      var insertIndex = containerHtml.lastIndexOf('</div>');
      containerHtml = containerHtml.slice(0, insertIndex) + favHtml + '\n' + containerHtml.slice(insertIndex);

    } else if (!useFallbackParams && nonFavoriteContent && nonFavoriteContent.type === 'circle') {
      // Create a dot and put it in a container with a star
      newMarkerParams.className += ' lyr_favDotContainer';

      var size = nonFavoriteContent.radius * 2;
      newMarkerParams.iconSize = 24;
      newMarkerParams.imagewidth = size;

      var color = nonFavoriteContent.fillcolor;
      newMarkerParams.fillcolor = color;

      var dotOffset = 24 / 2 - nonFavoriteContent.radius;
      var starOffset = 12 - nonFavoriteContent.radius + 2 - 9;

      // With normal map content, each circle is a path in a larger svg. Here, a div is used
      var dotStyle = 'background-color: '+ color + '; height: ' + size + 'px; width: ' + size + 'px; margin: ' + dotOffset + 'px;';
      var dotHtml = Hafas.Modules.Render.renderTemplate('Common_Map_LocationDotMarker', {style: dotStyle});
      var favStyle = 'top: ' + starOffset + 'px; right: ' + starOffset + 'px;';
      favHtml = Hafas.Modules.Render.renderTemplate('Common_Map_IconMarker', {imageUrl: starIconPath, className: 'lyr_mapFavStar', style: favStyle});
      containerHtml = dotHtml + favHtml;

    } else {
      // Calculate marker styles
      // Set default parameters
      var height = FALLBACK_ICON_SIZE;
      var width = FALLBACK_ICON_SIZE;
      var imageUrl = Hafas.Util.getImage(location.icoResolved.res);
      var fillColor = location.icoResolved.bg;

      // If marker exists and has necessary parameters, overwrite default parameters
      if (!useFallbackParams && nonFavoriteContent) {
        height = nonFavoriteContent.imageheight || height;
        width = nonFavoriteContent.imagewidth || width;
        imageUrl = nonFavoriteContent.imageurl || imageUrl;
        fillColor = nonFavoriteContent.fillcolor || fillColor;
      }

      var productStyle = 'width: ' + width + 'px;';
      productStyle += ' height: ' + height + 'px;';
      productStyle += ' margin-top: -' + width / 2 + 'px;';
      productStyle += ' margin-left: -' + height / 2 + 'px;';

      newMarkerParams.imagewidth = width;

      if (!isSmartLocationWithProd) {
        // Set containerHTML and container class only if the location is not a smart location
        containerHtml = Hafas.Modules.Render.renderTemplate('Common_Map_IconMarker', {imageUrl, style: productStyle});
        containerHtml += Hafas.Modules.Render.renderTemplate('Common_Map_IconMarker', {imageUrl: starIconPath, className: 'lyr_mapFavStar'});
        newMarkerParams.className += ' lyr_mapFavContainer' + width;
      } else {
        // Set imageurl
        if (location.smartLocation.prod) {
          var imgRes = location.smartLocation.prod;
          if (location.smartLocation.prod.startsWith('haf_')) {
            imgRes = location.smartLocation.prod.slice(4);
          }
          imageUrl = Hafas.Util.getImage(imgRes);
          newMarkerParams.imageurl = imageUrl;
        }
        // Fillcolor should be default gray
        fillColor = '';
      }

      newMarkerParams.fillcolor = fillColor;
    }

    if (containerHtml) {
      newMarkerParams.html = containerHtml;
      newMarkerParams.anchor = 'center';
    }

    if (!isSmartLocationWithProd && nonFavoriteContent && nonFavoriteContent.onclick) {
      if (nonFavoriteContent.type === 'container' || nonFavoriteContent.type === 'location') {
        newMarkerParams.onclick = function (map, markerParams) {
          nonFavoriteContent.onclick(mapInstance, markerParams);
        };
      } else if (nonFavoriteContent.type === 'circle') {
        newMarkerParams.onclick = function (map, markerParams) {
          nonFavoriteContent.onclick(mapInstance, markerParams);
          mapInstance.selectLocation(markerParams);
          mapController.mobilityRadar.selectedLocation = location.extId;
        };
      }
    } else {
      newMarkerParams.onclick = function (map, markerParams) {
        Hafas.ps.pub('/map/clickOnLocation', [mapInstance, location, null, markerParams]);
        if (Hafas.Config.Maps.toolbox.showLines === true && location.type === 'S') {
          Hafas.ps.pub('/map/clickOnLocation/getLocDetails', [location]);
        }
        mapInstance.selectLocation(markerParams);
        mapController.mobilityRadar.selectedLocation = location.extId;
      };
    }

    if (nonFavoriteMarkerRef) {
      // Hide but don't remove, so it can be easily restored when unfavorited
      mapInstance.hideContent(nonFavoriteMarkerRef);
    }

    // Create content
    var newMarkerRef = mapInstance.createContent(newMarkerParams);
    mapController.favoriteMarkers[markerId] = newMarkerRef;
    mapInstance.showContent(newMarkerRef);

    // If location was selected (flyout opened), select and highlight the new marker on the map again
    if ((nonFavoriteContent && nonFavoriteContent.selectionContent) || isSelected) {
      Hafas.bind(mapController.replaceMapSelection, this)(newMarkerRef);
      // Remove temporary flyout marker if necessary
      Hafas.ps.pub('/map/removeFlyoutLocationMarker');
    }

    // If the marker should only be visible while the flyout is open, store the reference as flyoutLocationMarker
    if (isTemp) {
      mapController.flyoutLocationMarker = newMarkerRef;
    }
  },
  /**
   * Remove the favorite marker for a location from the map.
   * @param {Object} location - The location being removed from favorites
   * @param {Object} [options] - Further instructions for removing the marker
   * @param {boolean} [options.ignoreMainMast] - Only relevant for submasts. If true, the markers for the main mast and other submasts will not be removed
   * @param {boolean} [options.ignoreSubMasts] - Only relevant for main masts. If true, the markers for submasts of the location will not be removed
   */
  removeFavoriteMarker: function (location, options) {
    if (!location) {
      console.warn('No location set!!!');
      return;
    }

    var mapController = this.Controller.Map;

    var ignoreMainMast = options && options.ignoreMainMast || false;
    var ignoreSubMasts = options && options.ignoreSubMasts || false;

    if (location.mMastLocResolved && !ignoreMainMast) {
      // If location references a main mast, remove favorite marker for the main mast
      // The marker for the current location and all other submasts of the main mast will be removed recursively
      Hafas.ps.pub('/map/removeFavoriteMarker', [location.mMastLocResolved]);
      return;
    }

    if (location.isMainMast && !ignoreSubMasts) {
      // If location is flagged as a main mast, find locations that reference it and remove their favorite markers
      var locationData = mapController.mobilityRadar ? mapController.mobilityRadar.locationData : {};
      var submasts = Object.values(locationData).filter(loc => loc.location.mMastLocResolved && loc.location.mMastLocResolved.extId === location.extId);
      submasts.forEach(loc => {
        Hafas.ps.pub('/map/removeFavoriteMarker', [loc.location, {ignoreMainMast: true}]); // ignoreMainMast to avoid infinite loops
      });
    }

    var mapInstance;
    if (Hafas.Config.layoutMode === '_classic') {
      mapInstance = mapController.selectionMap;
    } else {
      mapInstance = mapController.instance;
    }

    if (!mapInstance) {
      return;
    }

    // Get container ID
    var locIdentifier = location.extId;
    var markerTmpl = "FAV_" + locIdentifier;
    var markerId = "marker" + markerTmpl;

    // Store selection halo/highlight (if available) before removing content from map
    var favoriteMarkerRef = mapController.favoriteMarkers[markerId];
    var favoriteContent = mapInstance.getContent(favoriteMarkerRef);
    var selectionMarkerRef = favoriteContent ? favoriteContent.selectionContent : null;

    // Remove favorite container
    if (favoriteMarkerRef != null) {
      mapInstance.hideContent(favoriteMarkerRef);
      mapInstance.removeContent(favoriteMarkerRef);
      delete mapController.favoriteMarkers[markerId];
    }

    // Show and select non-favorite location marker if map options are activated or location is currently selected
    var newMarkerRef = mapController.mobilityRadar.getContentReference(location.extId);
    if (newMarkerRef != null || selectionMarkerRef != null) {
      if (newMarkerRef != null) {
        // Location should be visible due to activated map options
        // Simply use marker previously created in mobilityRadar
        mapInstance.showContent(newMarkerRef);
      } else {
        // Location should be visible because flyout is open, but map options are deactivated
        // Create new marker without star
        var FALLBACK_ICON_SIZE = Hafas.Config.Maps.Marker.FALLBACK_ICON_SIZE;
        var image = {
          data: {type: location.type},
          imageurl: Hafas.Util.getImage(location.icoResolved.res),
          imagewidth: FALLBACK_ICON_SIZE,
          imageheight: FALLBACK_ICON_SIZE,
          hotspot: {
            x: FALLBACK_ICON_SIZE / 2,
            y: FALLBACK_ICON_SIZE / 2
          },
          fillcolor: location.icoResolved.bg,
          priority: 10000,
          text: location.name,
          draggable: false
        }
        newMarkerRef = Hafas.Util.maps.showHCILocation(location, mapInstance, image, false);
        // Store non-favorite marker reference, so it can be removed when closing the flyout
        mapController.flyoutLocationMarker = newMarkerRef;
      }
      // In either case, select the new location marker if the old one was selected
      if (selectionMarkerRef != null) {
        Hafas.bind(mapController.replaceMapSelection, this)(newMarkerRef);
      }
    }
  },
  /**
   * Update the marker reference in the flyout and select and highlight the new marker.
   * @param {string} newMarkerRef - The reference for the new marker
   */
  replaceMapSelection: function (newMarkerRef) {
    var mapInstance = this.Controller.Map.instance;
    var newMapContent = mapInstance.getContent(newMarkerRef);
    mapInstance.updateToolboxItemMarkerRef(newMarkerRef, 'mapSelection');

    if (!newMapContent.className || !newMapContent.className.includes('lyr_productGroupContainer')) {
      // If content is not a product group container, highlight by adding halo
      mapInstance.selectLocation(newMapContent);
    } else if (newMapContent.containerHTMLElement) {
      // If content is a product group container, highlight by adding class
      var productGroupMarker = Hafas('.lyr_productGroupMarker', false, newMapContent.containerHTMLElement);
      if (productGroupMarker) {
        productGroupMarker.addClassName('lyr_productGroupHighlighted');
      }
    }
  },
  resetMobilityRadarSelection: function () {
    if (this.Controller.Map.mobilityRadar) {
      this.Controller.Map.mobilityRadar.resetLocationSelection();
    }
  },
  reverseLookUp: function (crd, par) {
    var mapController = this.Controller.Map;

    // typ muss gesetzt sein
    if ((typeof par.data != 'undefined') && (typeof par.data.type != 'undefined')) {

      // connection vorhanden, also neue route berechnen
      // Instant Drag & Drop
      if (typeof mapController.connection != 'undefined') {
        // Suche mit aktueller Koordinate
        if (typeof mapController.dragDropTimeout != 'undefined' && mapController.dragDropTimeout != null) {
          window.clearTimeout(mapController.dragDropTimeout);
        }
        mapController.dragDropTimeout = window.setTimeout(Hafas.bind(function () {
          this.Controller.Map.currentDragRequestCounter++;
          this.Controller.Map.dragConnection(crd, par.data.type, this.Controller.Map.currentDragRequestCounter);
        }, this), 300);
      }

    }
  },
  updateSelectionView: function (crd) {
    var availableMarkers = ['START', 'DEST', 'VIA'];
    var allMarkers = [];
    var mapInstance = this.instance;
    for (var i = 0; i < availableMarkers.length; i++) {
      if (this['marker' + availableMarkers[i]] != null) {
        allMarkers.push(this['marker' + availableMarkers[i]]);
      }
    }
    var selectionVisible = mapInstance.isPointInBoundingBox(crd);
    if (allMarkers.length > 1) {
      // mgab: Darf nicht bei Drag&Drop ausgeführt werden, vorerst auskommentiert
      if (!selectionVisible) {
        this.instance.centerToContent(allMarkers, {maxZoom: 14});
      }
    } else if (allMarkers.length == 1) {
      if (!selectionVisible) {
        mapInstance.centerToGeo(mapInstance.content[allMarkers[0]].coord);
      }
      //mapInstance.centerToContent(allMarkers[0],{maxZoom: mapInstance.getZoom("api")});
    }
  },
  sideDrawer: {
    bodyClick: function () {
        Hafas.ps.pub('/map/sidedrawer/close');
    },
    toggle: function (opts) {
      var pageHeaderHeight = 0;
      var _me = this;
      if (Hafas.Config.UI.showPageHeader) {
        pageHeaderHeight = Hafas("#HFS_PageHeader").clientHeight;
      }

      // ++/map/sidedrawer/toggle++
      if (opts.ev) {
        opts.ev.preventDefault();
        opts.ev.stopPropagation();
      }
      var $sideDrawer = Hafas('#' + this.mapSideDrawer);
      var isMobile = document.getElementById('HFS_WebApp').classList.contains('js-map-as-single-view');
      if (isMobile) {
        //HDSWAPP-3558: take elements temporarily out of tabIndex so that screenreaders dont read not visible buttons
        var mapSearchButton = document.getElementById("HFS_MapSearchMobilButton");
        var mapOptionButton = document.getElementById("HFS_MapOptioneMobileButton");
        if (mapSearchButton.hasAttribute("tabIndex")) {
          mapSearchButton.removeAttribute("tabIndex");
          mapOptionButton.removeAttribute("tabIndex");
        } else {
          mapSearchButton.setAttribute("tabIndex","-1");
          mapOptionButton.setAttribute("tabIndex","-1");
        }

        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTriggerMobile, false);
      } else {
        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
      }
      $sideDrawer.style.top = pageHeaderHeight + 'px';

      if ($sideDrawerTrigger.className.match(/js_sideDrawerOpened/g)) {
        Hafas.bind(this.Controller.Map.sideDrawer.close, this)();
      }
      else {
        Hafas.bind(this.Controller.Map.sideDrawer.show, this)();
        Hafas.ps.pub('/tracking/event/mobilitymap-options-main', [{typ: 'event', key: 'mobilitymap-options-main'}]);
        Hafas.ps.pub('/tracking/event/mobilitymap-options-pressed', [{
          typ: 'event',
          key: 'mobilitymap-options-pressed'
        }]);
      }
      $sideDrawer.scrollTop = 0;
    },
    show: function () {

      var $sideDrawer = Hafas('#' + this.mapSideDrawer);
      //var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
      var isMobile = document.getElementById('HFS_WebApp').classList.contains('js-map-as-single-view');
      if (isMobile) {
        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTriggerMobile, false);
      } else {
        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
      }
      //document.body.style.overflowY = 'hidden';

      $sideDrawer.removeAttribute('hidden');
      $sideDrawer.addClassName('js_sideDrawerOpened');
      $sideDrawerTrigger.addClassName('js_sideDrawerOpened');

      $sideDrawer.addEventListener('click', function (ev) {
        ev.stopPropagation();
      });
      document.body.addEventListener('click', this.Controller.Map.sideDrawer.bodyClick);

      if (Hafas.Modules.History)
        Hafas.Modules.History.addSubView("/map/sidedrawer/close", "MapMenu", {});

      Hafas.ps.pub('/GUI/sidedrawer/onChanged');

      Hafas.Util.gui.restoreFocus('button.lyr_sideDrawHeader');
    },
    close: function () {
      var $sideDrawer = Hafas('#' + this.mapSideDrawer);
      //var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
      var isMobile = document.getElementById('HFS_WebApp').classList.contains('js-map-as-single-view');
      if (isMobile) {
        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTriggerMobile, false);
      } else {
        var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
      }

      if ($sideDrawer.className.match(/js_sideDrawerOpened/g)) {
        //document.body.style.overflowY = 'auto';
        //Hafas('#HFS_SideDrawerMask', false).parentNode.removeChild(Hafas('#HFS_SideDrawerMask', false));
        $sideDrawer.hidden = true;
        $sideDrawer.removeClassName('js_sideDrawerOpened');
        $sideDrawerTrigger.removeClassName('js_sideDrawerOpened');
        document.body.removeEventListener('click', this.Controller.Map.sideDrawer.bodyClick);

        if (Hafas.Modules.History)
          Hafas.Modules.History.removeCurrentStep("MapMenu");

        Hafas.ps.pub('/GUI/sidedrawer/onChanged');
      }

      Hafas.Util.gui.restoreFocus(Hafas.Util.node.getPath($sideDrawerTrigger));
    },
    toggleGeoFeatureHint: function (show) {
      var div = Hafas("#HFS_mainZoomHint",false);
      var geoFeatureHints = Hafas('[data-zoom-hint="traffic"]',true);
      geoFeatureHints.forEach(function(elem){
        Hafas.Util.gui.setVisibility(elem, show);
      });
      Hafas.Util.gui.setVisibility(div, show);
      // Footnote linked with checkbox for accessiblity
      var zoomHintCheckbox = Hafas('input[data-mobilityradar-content="traffic"]');
      if (zoomHintCheckbox) {
        if (show) {
          zoomHintCheckbox.setAttribute('aria-describedby', 'HFS_mainZoomHint');
        } else {
          zoomHintCheckbox.removeAttribute('aria-describedby');
        }
      }
    },
    resize: function (opts) {
      // ++/map/sidedrawer/resize++
      if (Hafas.Config.UI.showPageHeader)
        var pageHeaderHeight = Hafas("#HFS_PageHeader").clientHeight;
      else
        var pageHeaderHeight = 0;

      var $sideDrawer = Hafas('#' + this.mapSideDrawer, false);
      $sideDrawer.style.height = (window.innerHeight - pageHeaderHeight) + 'px';
    },
    toggleList: function (opts) {
      var currentVisibilityStatus = Hafas.ps.pub('/GUI/common/atomToggleContainer', [opts]);
      var OptionName = Hafas('.lyr_atomLabel', true, opts.trigger)[0].innerHTML;

      if (Hafas.Config.Maps.useSingleOpenCatMode)
        this.Controller.Map.sideDrawer.closeAllLists(opts.trigger);

      var tooltipContainer = Hafas('.lyr_expandCollapseIcon', false, opts.trigger);
      var tooltipText = Hafas('.lyr_tooltipText', false, tooltipContainer);
      if (typeof currentVisibilityStatus !== "undefined" && currentVisibilityStatus === true) {
        tooltipText.innerHTML = Hafas.Modules.i18n.get('common.label.t_N_HideOption', {OptionName: OptionName});
      } else {
        tooltipText.innerHTML = Hafas.Modules.i18n.get('common.label.t_N_ShowOption', {OptionName: OptionName});
      }
      if(Hafas.Config.Switches.useOnboarding) {
        var _triggerDomId = Hafas('#' + opts.trigger.id,false).getAttribute('aria-controls');
        var anchorElement = Hafas('#' + _triggerDomId + ' .lyr_onboardingTooltipWrapper',false);
        var _me = this;
        if (anchorElement !== null && Hafas.Util.gui.isVisible(anchorElement)) {
          Hafas.ps.pub('/gui/showOnboardingToolTip', [{
            id: "zoomLevel",
            context: "sideDrawer",
            anchorElement: anchorElement,
            closeCallback: function (){
              Hafas.Util.stopPropagation();
              document.body.addEventListener('click', _me.Controller.Map.sideDrawer.bodyClick);
            },
            openCallback: function (){
              document.body.removeEventListener('click', _me.Controller.Map.sideDrawer.bodyClick);
            }
          }]);
        }
      }
    },
    closeAllLists: function (except) {
      var options = {
        open: false
      };
      var tabList = Hafas(".lyr_sideDrawItemTab", true);
      for (var i = 0; i < tabList.length; i++) {
        var tab = tabList[i];

        if (tab === except)
          continue;

        options.trigger = tab;
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [options]);
      }
    }
  },
  /**
   * link footnote for accessibility with checkbox
   * @param {string} id
   * @param {boolean} show
   */
  linkZoomHintWithCheckbox: function (id, show) {
    var checkbox = Hafas('input[data-mobilityradar-content="' + id + '"]', false);
    if (checkbox) {
      var categoryId = checkbox.getAttribute('data-mobilityradar-category');
      var hintId = '';
      // Customization for POI Id: HFS_SideDrawList_multimodal_poi
      if(categoryId.indexOf('multimodal_poi') !== -1) {
        hintId = 'HFS_SideDrawerZoomHintpoi_multimodal_poi';
      } else {
        hintId = 'HFS_SideDrawerZoomHint' + categoryId;
      }
      if (show) {
        checkbox.setAttribute('aria-describedby', hintId);
      } else {
        checkbox.removeAttribute('aria-describedby');
      }
    }
  },
  toggleZoomHint: function (id, show) {
    var item = Hafas('[data-zoom-hint="' + id + '"]', false);
    if (item)
      Hafas.Util.gui.setVisibility(item, show);
  },
  disableContent: function (content, disableBool, type) {
    this.Controller.Map.toggleZoomHint(content.id, disableBool);
    this.Controller.Map.linkZoomHintWithCheckbox(content.id, disableBool);
  },
  updateMapContentDisableStatus: function (boolval, group) {
    this.Controller.Map.toggleZoomHint(group, boolval);
    this.Controller.Map.linkZoomHintWithCheckbox(group, boolval);
  },
  hideConnection: function (opts) {
    if (this.connection) {
      this.connection.hide(opts);
    }
  },
  hideDragRoute: function () {
    if (this.dragRoute) {
      Hafas.Util.maps.hideHCITrips([this.dragRoute], this.main.Controller.Map.instance);
      this.dragRoute = null;
    }
  },
  hideTripMarker: function () {
    if (this.markerSTART != null) {
      this.instance.hideContent(this.markerSTART);
    }
    if (this.markerDEST != null) {
      this.instance.hideContent(this.markerDEST);
    }
    // Via Marker auch weglöschen
    if(Hafas.Config.TP.vias.amount > 0) {
      this.main.Controller.Map.hideAllViaMarker.bind(this.main)();
    }
  },
  restoreTripMarker: function () {
    if (this.markerSTART != null) {
      this.instance.showContent(this.markerSTART);
    }
    if (this.markerDEST != null) {
      this.instance.showContent(this.markerDEST);
    }
    if (this.markerVIA != null) {
      this.instance.showContent(this.markerVIA);
    }
  },
  centerLocation: function (data) {
    if (data.type == 'dep') {
      this.Controller.Map.connection.centerLocation(data.secIdx, 'dep');
    } else if (data.type == 'arr') {
      this.Controller.Map.connection.centerLocation(data.secIdx, 'arr');
    } else if (data.type == 'intermediate') {
      this.Controller.Map.connection.centerLocation(data.secIdx, data.locIdx);
    }
  },
  centerSection: function (data) {
    this.Controller.Map.connection.centerToSection(data.secIdx);
  },
  centerSegment: function (data) {
    this.Controller.Map.connection.centerToSegment(data);
    if (this.layoutClass === 'small' && Hafas.Config.Switches.useMap) {
      Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderConnection', type: 'centerSegment'}]);
    }
  },
  removeHighlightSegment: function () {
    this.Controller.Map.connection.removeSegmentHighlightPolyline();
  },
  showConnection: function (connection, options) {
    this.connection = Hafas.Core.newType("hafasConnection", connection, this.instance);
    try {
      this.connection.show(options);
      this.connection.centerRoute();
      this.hideTripMarker();
      Hafas.ps.pub('/map/showConnectionOnMap', [connection]);

      // Tracking
      Hafas.ps.pub('/tracking/screen/map', [{typ: 'screen', key: 'map', data: {type: 'routedetails'}}]);
    }
    catch (e) {
      Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "map.showConnection", "Fehler beim zeichnen einer Verbindung!", e);
    }
  },
  showCurrentConnection: function () {
    if (this.connection) {
      this.connection.show();
      this.connection.centerRoute();
      this.hideTripMarker();
    }
  },
  locationDrag: function (coord, mapContent, evt) {
    if (this.dragDropDelay) {
      window.clearTimeout(this.dragDropDelay);
      this.dragDropDelay = null;
    }
    this.dragDropDelay = window.setTimeout(Hafas.bind(function () {
      if (mapContent.data == undefined)
        return;
      var type = mapContent.data.type;
      this.Controller.Map.currentDragRequestCounter++;
      this.Controller.Map.dragConnection(coord, type, this.Controller.Map.currentDragRequestCounter);
    }, this), 300);
  },
  locationDragEnd: function (crd, mapContent, map) {

    var mapController = this.Controller.Map;
    var zoom = map.getZoom("api");
    var type = null;  // ggf. steht kein Typ fest
    if ((typeof mapContent.data != 'undefined') && (typeof mapContent.data.type != 'undefined')) {
      type = mapContent.data.type;
    }

    // ggf. timeout fuer "suchvorschau" entfernen
    if (typeof mapController.dragDropTimeout != 'undefined' && mapController.dragDropTimeout != null) {
      window.clearTimeout(mapController.dragDropTimeout);
    }

    // vermeiden, dass ggf. noch responses von der drag-bewegung verarbeitet werden
    mapController.currentDragRequestCounter++;

    // kein typ gesetzt, dann wie klick auf karte handhaben (reverselookup)
    if (!type) {
      map.showReverseLookupToolbox(crd);
    }
    else {
      Hafas.Util.geo.reverseLookup(crd, Hafas.bind(function (locL,common) {
        // ort als start/ziel setzen
        var location = locL[0];
        Hafas.Util.getRef("ico", common, location);
        Hafas.Util.location.resolveProductList([location], common);
        this.Controller.TP.instance.setLocation(type, location);

        var initSearch = false;

        // ort ist start und es ist bereits ein ziel gesetzt, dann suche starten
        if ((type == 'dep') && (this.Controller.TP.instance.getLocation('arr'))) {
          Hafas.bind(mapController.setLocationMarker, this)('arr', this.Controller.TP.instance.getLocation('arr'));
          initSearch = true;
        }
        else if ((type == 'arr') && (this.Controller.TP.instance.getLocation('dep'))) {
          Hafas.bind(mapController.setLocationMarker, this)('dep', this.Controller.TP.instance.getLocation('dep'));
          initSearch = true;
        }

        // Suche Starten, wenn bereits vorher einmal gesucht wurde
        if ((initSearch)) {

          // bisherige verbindung ausblenden (inkl. der marker)
          if (typeof mapController.connection != 'undefined') {
            mapController.hideConnection({startDestMarker: true});
          }
          this.Controller.TP.selectedConnection = null;
          // ggf. auch eine drag-vorschau-route
          mapController.hideDragRoute();
          mapController.hideDragHint();

          // dieses cluster soll nach der suche angezeigt werden (ist ggf nicht das default cluster)
          if (Hafas.Config.TP.useGrouping) {
            var tpController = this.Controller.TP;
            for (var cIdx = 0; cIdx < Hafas.Config.TP.cluster.length; cIdx++) {
              if (Hafas.Config.TP.cluster[cIdx].type == tpController.visibleClusterGroup) {
                tpController.showClusterGroup = {
                  id: tpController.visibleClusterGroup, clusterIndex: cIdx
                };
                break;
              }
            }
          }

          this.Controller.TP.instance.search({
            ptCallback: Hafas.bind(this.Controller.TP.showResultOverview, this),
            ivCallback: Hafas.bind(this.Controller.TP.showIVResultOverview, this)
          });
        }
      }, this), function () {
      }, {zoomDependent: true, zoom: zoom});
    }
    Hafas.ps.pub('/tracking/event/tripplanner-dragdrop-gesture-completed', [{
      typ: 'event',
      key: 'tripplanner-dragdrop-gesture-completed'
    }]);
  },
  dragConnection: function (coord, type, reqIndex) {
    if (!Hafas.Config.TP.useDragPreview)
      return;
    if (this.connection == undefined)
      return;

    var mapController = this;

    var draggedHciLocation = Hafas.Util.location.createByCoordinate(coord.getLon(), coord.getLat());
    var meterPerPixel = mapController.instance.getZoom("meter_x") / mapController.instance.mapDiv.clientWidth;
    var distValue = meterPerPixel * 15;
    draggedHciLocation.dist = distValue;
    draggedHciLocation.pCls = 63;
    Hafas.Util.location.addEteId(draggedHciLocation);
    var destLoc = this.main.Controller.TP.instance.getLocation('arr');
    var startLoc = draggedHciLocation;
    if (type == 'arr') {
      startLoc = this.main.Controller.TP.instance.getLocation('dep');
      destLoc = draggedHciLocation;
    }
    var dragConnection = Hafas.Core.newType('hafasTP', {
      depLocL: [startLoc],
      arrLocL: [destLoc],
      routePreview: true
    });

    // bisherige verbindung ausblenden
    mapController.hideConnection({startDestMarker: false});
    // ggf. auch eine drag-vorschau-route ausblenden
    mapController.hideDragRoute();
    mapController.hideDragHint();

    // neue verbindung suchen
    dragConnection.search({
      ptCallback: Hafas.bind(function (data) {
        // falls der request zu alt ist, dann ignorieren
        if (reqIndex < mapController.currentDragRequestCounter) {
          return;
        }

        // ggf. bisherige verbindung ausblenden
        mapController.hideConnection({startDestMarker: false});
        // ggf. auch eine drag-vorschau-route ausblenden
        mapController.hideDragRoute();
        mapController.hideDragHint();

        // verbindung gefunden?
        if (data.connectionResult.length > 0) {
          this.dragRoute = Hafas.Util.maps.createHCITrip(data.connectionResult[0].conn, this.main.Controller.Map.instance, data.connectionResult[0].common, {
            polyline: {
              show: true,
              params: {
                opacity: 0.7
              }
            },
            locations: {
              show: false
            }
          });
          Hafas.ps.pub('/map/dragDrop/connectionFound', [coord, data.renderConnections[0]]);
        }
        else {
          Hafas.ps.pub('/map/dragDrop/noConnection', [coord]);
        }
      }, this)

    });
  },
  showDragHint: function (data) {
    this.Controller.Map.hideDragHint();
    var containerParams = {
      type: 'container',
      html: data.html,
      coord: data.coord
    };
    if (typeof data.className != 'undefined') {
      containerParams.className = data.className;
    }
    this.Controller.Map.dragHint = this.Controller.Map.instance.createContent(containerParams);
    this.Controller.Map.instance.showContent(this.Controller.Map.dragHint);
    if (typeof data.callback == 'function') {
      data.callback();
    }
  },
  hideDragHint: function () {
    if (typeof this.dragHint != 'undefined' && this.dragHint != null) {
      this.instance.hideContent(this.dragHint);
      this.instance.removeContent(this.dragHint);
    }
  },
  showDragConnectionPreview: function (coord, connection) {
    Hafas.Modules.Render.render(
      {
        file: 'common.map.html',
        template: 'Common_DragHintConnection',
        model: connection
      },
      Hafas.bind(function (htmlRendered) {
        Hafas.bind(this.Controller.Map.showDragHint, this)({
          className: 'hfs_dragHintOnMap',
          html: htmlRendered,
          coord: coord,
          callback: function () {
            Hafas.ps.pub('/GUI/durationBar/recalculate');
          }
        });
      }, this)
    );
  },
  showDragNoConnection: function (coord) {
    Hafas.Modules.Render.render(
      {
        file: 'common.map.html',
        template: 'Common_DragHint',
        model: {
          text: Hafas.Modules.i18n.get('TP.error.t_N_noResultsExtended')
        }
      },
      Hafas.bind(function (htmlRendered) {
        Hafas.bind(this.Controller.Map.showDragHint, this)({
          html: htmlRendered,
          coord: coord
        });
      }, this)
    );
  },
  showConnectionMap: function (conn, opts) {
    this.main.Controller.Map.connectionMaps[opts.arrayIdx] = Hafas.Core.newType('hafasMapLeaflet', 'HFS_ConnectionMap_' + opts.arrayIdx, {
      coord: Hafas.Core.newType("hafasCCoord", Hafas.Config.Maps.predefinedArea),
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: false,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.Maps.staticTileURL,
        "attribution": "&copy; OpenStreetMap contributors",
        "isBaseLayer": true
      }]
    });

    var connectionConfig = {};

    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection = Hafas.Core.newType("hafasConnection", conn, this.main.Controller.Map.connectionMaps[opts.arrayIdx], connectionConfig);
    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection.show(opts);
    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection.centerRoute();
  },
  showGeoPosition: function () {
    if (typeof Hafas.Config.Maps.usePositionWatcher !== "undefined" && Hafas.Config.Maps.usePositionWatcher) {
      // Callback wird jedes mal, wenn die Position geändert wird getriggert.
      // Es soll jedoch nicht jedesmal die aktuelle Position zentriert werden.
      this.instance.activePositionWatcher = false;
      var _watcherCallback = function (position) {
        if (position && !this.instance.activePositionWatcher && typeof position.browserPosition !== 'undefined') {
          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(position.browserPosition.coords);
          this.instance.centerToGeo(crd, Hafas.Config.Maps.searchPredefinedZoom);
          this.instance.activePositionWatcher = true;
        }
      };
      Hafas.Util.geo.activateActualPositionWatcher(Hafas.bind(_watcherCallback, this), true);
    }
    else {
      // Alte Funktion:
      Hafas.Util.getGeoLocation(Hafas.bind(function (geoLoc) {
        if (typeof geoLoc.coords != 'undefined') {
          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(geoLoc.coords);
          this.instance.centerToGeo(crd, Hafas.Config.Maps.searchPredefinedZoom);
        }
      }, this), false, true);
    }
    // Tracking
    Hafas.ps.pub('/tracking/event/map-current-position-button-clicked', [{
      typ: 'event',
      key: 'map-current-position-button-clicked'
    }]);
    Hafas.ps.pub('/tracking/event/map-currentposition-pressed', [{typ: 'event', key: 'map-currentposition-pressed'}]);
  },
  hoverDetails: function (data) {
    try {
      var me = this,
        selectedGroup,
        results,
        currConnection;


      // hoverRoutes werden nur mit angeschlossener Maus angezeigt.
      if (Hafas.Util.hasMouseSupport()) {
        // Ergebnisse Gruppe
        if (this.Controller.TP.instance.isGroupingUsed() && this.Controller.TP.instance.data.results.isReconstruction == false) {

          if (data.connectionType == 'heart') {
            selectedGroup = this.Controller.TP.groupFavMode + '_score';
          } else {
            selectedGroup = data.connectionType;
          }

          results = this.Controller.TP.instance.data.results.groups[selectedGroup];
          currConnection = results.connections[data.arrayIdx].resolvedConnection;
        } else {
          results = this.Controller.TP.instance.data.results.connectionResult;
          currConnection = this.Controller.TP.instance.data.results.renderConnections[data.arrayIdx];
        }

        if (typeof me.hoverRoutes == 'undefined') {
          me.hoverRoutes = {};
        }

        // noch keine Verbindung geladen oder gehoverte verbindung ist die momentan sichtbare verbindung, dann ignorieren
        if ((typeof me.Controller.Map.connection == 'undefined') || (me.Controller.Map.connection.connectionData.cksum == currConnection.cksum)) {
          return
        }

        if (typeof me.hoverRoutes[currConnection.cksum] == 'undefined') {
          me.hoverRoutes[currConnection.cksum] = Hafas.Core.newType("hafasConnection", currConnection, this.Controller.Map.instance);
        }
        me.hoverRoutes[currConnection.cksum].show({
          centerRoute: false,
          stops: false,
          changes: false,
          opacity: 0.4
        });
      }
    } catch (e) {
      Hafas.logger.warn(
        Hafas.logger.ERROR_TYPES.JS,
        "map.hoverDetails",
        "",
        e
      );
    }
  },
  unhoverDetails: function (data) {
    var me = this;
    // hoverRoutes werden nur mit angeschlossener Maus angezeigt.
    if (typeof me.hoverRoutes != 'undefined' && Hafas.Util.hasMouseSupport()) {
      for (var r in me.hoverRoutes) {
        me.hoverRoutes[r].hide();
      }
    }
  },
  /**
   * Zeichnet die aktuelle Position auf der Karte.
   *
   * @method Controller.Map.showCurrentPositionMarker
   * @param location
   * @param targetId
   * @param accuracyRadius
   */
  showCurrentPositionMarkerPoint: function (location, accuracyRadius, changed) {
    // Diese Funktion zeigt die aktuelle Position mit einem Kreis auf der Karte an.
    var _map = this.Controller.Map;
    // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
    // var radius = accuracyRadius || 1000;
    // Wenn die Position sich verändert hat oder es noch gar keinen Positionsmarker gibt, soll dieser nun angezeigt werden
    if (location && location.crd && (changed || typeof _map.currentPositionMarker === "undefined")) {
      if (typeof _map.currentPositionMarker === 'undefined') {
        _map.currentPositionMarker = {};
      }
      var map = this.Controller.Map.instance;
      var newCrd = Hafas.Util.geo.hciCrdToHafasCoord(location.crd);
      // Standard-Position
      if (typeof _map.currentPositionMarker.crd === 'undefined') {
        _map.currentPositionMarker.crd = {
          param: {
            lat: 0,
            lon: 0
          }
        };
      }
      // Positionsänderung oder erste Position
      if ((_map.currentPositionMarker.crd.param.lat !== newCrd.param.lat &&
        _map.currentPositionMarker.crd.param.lon !== newCrd.param.lon)) {
        // Alte Marker abräumen
        if (_map.currentPositionMarker.whiteOutline) {
          map.hideContent(_map.currentPositionMarker.whiteOutline);
          map.removeContent(_map.currentPositionMarker.whiteOutline);
          _map.currentPositionMarker.whiteOutline = null;
        }
        if (_map.currentPositionMarker.innerCircle) {
          map.hideContent(_map.currentPositionMarker.innerCircle);
          map.removeContent(_map.currentPositionMarker.innerCircle);
          _map.currentPositionMarker.innerCircle = null;
        }
        // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
        // if(_map.currentPositionMarker.accuracyRadius) {
        //   map.hideContent(_map.currentPositionMarker.accuracyRadius);
        //   map.removeContent(_map.currentPositionMarker.accuracyRadius);
        //   _map.currentPositionMarker.accuracyRadius = null;
        // }
        if (_map.instance.isPointInGlobalBoundingBox(newCrd)) {
          _map.currentPositionMarker = {
            crd: newCrd,
            whiteOutline: map.createContent({
              type: 'circle',
              coord: newCrd,
              radius: 6,
              color: '#FFFFFF',
              opacity: 1,
              unit: 'pixel'
            }),
            innerCircle: map.createContent({
              type: 'circle',
              coord: newCrd,
              radius: 4,
              color: Hafas.Config.Styling.ColorSchemes[Hafas.Core.getColorScheme()]['lyr-primary'],
              opacity: 1,
              unit: 'pixel'
            })

            // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
            // accuracyRadius: map.createContent({
            //   type: 'circle',
            //   coord: newCrd,
            //   radius: radius,
            //   color: Hafas.Config.Styling.PrimaryClr,
            //   opacity: 0.1,
            //   fillOpacity: 0.2,
            //   unit: 'meter'
            // })
          };
          // map.showContent(_map.currentPositionMarker.accuracyRadius);
          map.showContent(_map.currentPositionMarker.whiteOutline);
          map.showContent(_map.currentPositionMarker.innerCircle);
        }
        else {
          if (!_map.locationAlertShowed) {
            alert(Hafas.Modules.i18n.get('common.locationErrors.t_N_outsideBoundingBox'));
            _map.locationAlertShowed = true;
          }
        }
      }
    }
  },
  /**
   * Löscht die aktuelle Position auf der Karte.
   *
   * @method Controller.Map.hideCurrentPositionMarker
   */
  hideCurrentPositionMarkerPoint: function () {
    var _map = this.Controller.Map;
    if (typeof _map.currentPositionMarker === 'undefined') {
      return false;
    }
    var map = this.Controller.Map.instance;
    // Alte Marker abräumen
    if (_map.currentPositionMarker.whiteOutline) {
      map.hideContent(_map.currentPositionMarker.whiteOutline);
      map.removeContent(_map.currentPositionMarker.whiteOutline);
      _map.currentPositionMarker.whiteOutline = null;
    }
    if (_map.currentPositionMarker.innerCircle) {
      map.hideContent(_map.currentPositionMarker.innerCircle);
      map.removeContent(_map.currentPositionMarker.innerCircle);
      _map.currentPositionMarker.innerCircle = null;
    }
    // if (_map.currentPositionMarker.accuracyRadius) {
    //   map.hideContent(_map.currentPositionMarker.accuracyRadius);
    //   map.removeContent(_map.currentPositionMarker.accuracyRadius);
    //   _map.currentPositionMarker.accuracyRadius = null;
    // }
    _map.currentPositionMarker = undefined;
    return true;
  },
  handleDroppedMarker: function (screenCoords, markerType) {
    var map = this.Controller.Map.instance;
    var crd = map.scr2geo(screenCoords);
    var zoom = map.getZoom("api");
    Hafas.Util.geo.reverseLookup(crd, Hafas.bind(function (locL) {
      // ort als start/ziel setzen
      this.Controller.TP.instance.setLocation(markerType, locL[0]);

    }, this), function () {
    }, {zoomDependent: true, zoom: zoom});
  },
  toggleNetSpider: function (type, boolval, data) {
    if (boolval) {
      var polyData = Hafas.bind(this.Controller.Map.showGraph, this)({
        type: 'LocGraph',
        locL: [data.lid]
      });
    } else {
      for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
        Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g], this.Controller.Map.instance, true);
      }
    }
  },

  handleReverseLookupResult: function (map, crd, loc) {
    if ((Hafas.Config.Maps.toolbox.showLines == true && loc.type == 'S' && typeof loc.productRefList == 'undefined') || loc.type == 'P') {
      Hafas.Util.location.getLocDetails(loc, function(data, locationData){
        var resolvedLocation = data.svcResL[0].res.locL[0];
        this.Controller.Map.renderLocDetails.bind(this)(resolvedLocation.extId, resolvedLocation);
      }.bind(this));
    }
  },
  toggleNearStations: function (boolval, loc) {
    if (boolval) {
      if (Hafas.Config.Maps.toolbox.showAdrNearStops == true && loc.type != 'S') {
        this.Controller.Map.getNearbyStops(loc);
      }
    }
  },
  getNearbyStops: function (location) {
    var requestObj = {
      ring: {
        cCrd: {
          y: parseInt(location.crd.y),
          x: parseInt(location.crd.x)
        },
        maxDist: Hafas.Config.Maps.toolbox.stationsNearRadius
      },
      getPOIs: false,
      getStops: true,
      maxLoc: 3
    };

    var targetContainer = Hafas('[data-toolbox-stationboard-stationsnear="' + location.extId + '"]', false);

    Hafas.Core.newType('hafasRequest', {
      request: "LocGeoPos",
      requestType: "hci",
      requestobj: requestObj,
      loadingModule: "LocGeoPos",
      callback: function (res) {
        if (typeof res.svcResL != 'undefined' && res.svcResL.length > 0) {
          var result = res.svcResL[0].res;
          var distances = [];
          for (var l = 0; l < result.locL.length; l++) {
            Hafas.Util.getRef("ico", result.common, result.locL[l]);
            distances.push(result.locL[l].dist);
          }
          var minDistance = Math.min.apply(null, distances);
          Hafas.Util.location.resolveProductList(result.locL, result.common);

          Hafas.Modules.Render.render(
            {
              target: targetContainer,
              file: 'map.flyout.html',
              template: 'Common_Flyout_StationNear',
              model: {
                locL: result.locL,
                minDistance: Hafas.Util.getDistanceInUnit(minDistance),
                showAdrNearStopsBoards: Hafas.Config.Maps.toolbox.showAdrNearStopsBoards
              }
            },
            Hafas.bind(function (htmlRendered) {
              html = htmlRendered;
            }, this)
          );
        }
      }
    });
  },
  /**
   * Selects a location on the map, creates a marker and opens a toolbox
   * @param {object|String} loc Location object (from internal call) or lid string (from URL)
   * @param {number} zoom Zoom level the map will be set on, default 14
   */
  createLocationSelection: function(loc, zoom) {
    var callback = function(location) {
      // We have a full location here, center the map, create and show the toolbox
      var map = this.Controller.Map.instance;
      map.centerToGeo(Hafas.Util.geo.hciCrdToHafasCoord(location.crd), zoom || 14, {considerOffset:false});

      var options = {
        placeMarker: true,
        lazyLoadLines: false
      };
      var toolbox = Hafas.Modules.Maps.getToolbox({location: location, options: options});
      toolbox.show(map);

      this.Controller.Map.renderExternalContentButtons(location);
    };
    if (typeof loc === "string" || loc.type === 'S' || loc.type === 'P') {
      // If location comes via URL and is just a lid, get the full location and resolve its values
      // Or: Even if we already have a location object, tariff data with external content might be missing
      var lid = typeof loc === 'string' ? loc : loc.lid;
      Hafas.Util.location.getLocDetails({lid: lid}, function (data) {
        var location = data.svcResL[0].res.locL[0];
        var common = data.svcResL[0].res.common;
        // Resolved products, icons, mcpData etc.
        Hafas.Util.location.enrichLocationAfterRequest(data.svcResL[0].res.locL, data.svcResL[0].res);

        // Callback to render basic flyout
        Hafas.bind(callback, this)(location);

        // Dynamically replace flyout content
        Hafas.bind(this.Controller.Map.renderLocDetails,this)(location.extId, location);

      }.bind(this));
    } else {
      // We do have a full location here and don't need the details
      Hafas.bind(callback, this)(loc);
    }
  },
  foldMapControls: function () {
    var controls = this.Controller.Map.instance.getControls();
    for (var c = 0; c < controls.length; c++) {
      var tmpControl = controls[c];
      if (typeof tmpControl.ctrlInstance != 'undefined' && typeof tmpControl.ctrlInstance.fold == 'function') {
        tmpControl.ctrlInstance.fold();
      }
    }
  },
  resizeFlyouts: function () {
    var map = this.Controller.Map.instance;
    var toolboxItems = map.getAllToolboxItems();
    if (toolboxItems.length > 0) {
      map.refreshFlyoutPosition(toolboxItems[0]);
    }
  },
  showControl: function (button, show) {
    Hafas.Util.gui.setVisibility(button, show);
  },
  resetWeatherTimeoutReference: function(){
    if(this.Controller.Map.weather.refreshTimeoutReference != null){
       window.clearTimeout(this.Controller.Map.weather.refreshTimeoutReference);
    }
  },
  /**
   * checks whether an update of the weather is needed (based on distance)
   *
   * @method isWeatherUpdateNeeded
   * @param {Object} updatedMapCenter - new updated map center (HafasCCoord)
   * @returns {Boolean}
   */
  isWeatherUpdateNeeded: function(updatedMapCenter){
    var mapController = this.Controller.Map;
    // If the weather has never been updated or if the distance between the origin map center and the new center is big enough
    if(mapController.weather.currentMapCenter == null){
      return true;
    }
    var distance = Hafas.Util.geo.distance(mapController.weather.currentMapCenter, updatedMapCenter);
    // If the distance of the map center is bigger than what is defined as a threshold in the server, then the weather needs to be updated
    if(distance > Hafas.Config.weatherConfig.refreshAfterDistance){
      return true;
    }else{
      return false;
    }
  },
  /**
   * gets/updates weather info for the map
   *
   * @method getWeatherInfo
   * @param {String} eventSource gives indication of the function call trigger. can be "mapViewUpdated" or "refresh"
   * @returns {Boolean}
   */
  getWeatherInfo:function (eventSource) {
    var mapController = this.Controller.Map;
    var map = mapController.instance;
    var weatherConfig = Hafas.Config.weatherConfig;

    // Check if map instance is ready
    if(map) {
      var mapCenter = map.getCenter();
      var mapCenterCrd = Hafas.Core.newType("hafasCCoord",{lon: mapCenter.param.lon, lat: mapCenter.param.lat });
      var zoom = map.getZoom("api");
      var weatherContainer = Hafas('#HFS_WeatherInfo', false);

      // If the zoom is below the configured min zoom (server side config) then clear the result of the weather control
      if (zoom < weatherConfig.minZoom) {
        weatherContainer.innerHTML = "";
        mapController.resetWeatherTimeoutReference.bind(this)();
        mapController.weather.currentMapCenter = null;
        return;
      }

      if(eventSource == 'mapViewUpdated' && Hafas.bind(this.Controller.Map.isWeatherUpdateNeeded,this)(mapCenterCrd) == false){
        return;
      }

      var coord = mapCenter.param;


      // Fire LocDetails Request in order to retrieve weather for current map center
      Hafas.Util.location.getCoordWeatherInfo(coord, Hafas.bind(function (weatherResult) {
        if (weatherResult.isAvailable)
          weatherContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_TplWeatherInfo", weatherResult);
        else
          weatherContainer.innerHTML = "";

        // After updating set a timeout to update the weather even when no movement has happened (refreshAfterElapsed is in seconds)
        mapController.resetWeatherTimeoutReference.bind(this)();
        mapController.weather.refreshTimeoutReference = window.setTimeout(this.Controller.Map.getWeatherInfo.bind(this,"refresh"), weatherConfig.refreshAfterElapsed * 1000);

        // Save coordinate of last request
        mapController.weather.currentMapCenter = mapCenterCrd;
      }, this), {
        'req.type': 'All'
      });
    }
  },
  /**
   * Shows the map loading indicator at the top center of the screen
   *
   * @method showMapLoadingControl
   */
  showMapLoadingControl: function(){
      Hafas.Util.gui.setVisibility(Hafas('#HFS_PageMapLoader'),true);
  },
  /**
   * Hides the map loading indicator at the top center of the screen
   *
   * @method hideMapLoadingControl
   */
  hideMapLoadingControl: function(){
    Hafas.Util.gui.setVisibility(Hafas('#HFS_PageMapLoader'),false);
  },
  /**
   * opens the map "context" from the sidedrawer main menu. It automatically restore the original map view and
   * clears previous content from the map
   *
   * @method openFromSidedrawer
   */
  openFromSidedrawer: function(){
    // It's important to remove map content for the current active context
    if(typeof this.Controller[this.appContext].clearMap == 'function') {
      this.Controller[this.appContext].clearMap.bind(this)();
    }
    // When coming from the LineSearch context is needed that additional functions are called
    if(this.appContext == 'LineSearch'){
      this.Controller.LineSearch.clearLivemap.bind(this)();
      Hafas.bind(this.Controller.LineSearch.unregisterDeviceSensors, this.Controller.LineSearch)();
    }
    this.Controller.GUI.map.show.bind(this)({trigger: this, ev: {}, template: 'Common_MapPageHeaderDefault'});

    // Also the initial map view should be restored when the "map" tab is clicked
    this.Controller.Map.restoreInitialMapView.bind(this)();
  },
  fullscreen: {
    buttonClicked: function (options, map, mapWrapperInstance) {
      var elementToShowInFullscreen = document.documentElement;
      // In formBased Mode we only want to show the individual map of the connection in fullscreen mode
      if(Hafas.Util.isFormBased()) {
        elementToShowInFullscreen = mapWrapperInstance.mapDiv;
      }
      Hafas.ps.pub('/GUI/fullscreen/toggle', [this.Controller.Map.instance.getControlById('fullscreen').ctrlInstance.getCurrentState().name, elementToShowInFullscreen]);
    },
    buttonCreated: function (button) {
      // two requisites
      //  1. only show the button if webapp is placed in an iframe -> otherwise it doesn't make much sense to have a fullscreen button
      //  2. only show the button if fullscreen functionality is available in this browser
      Hafas.ps.pub('/map/showControl', [button, ((Hafas.Util.appIsInIFrame() || Hafas.Util.isFormBased()) && Hafas.Util.fullscreen.isSupported())]);
    },
    changed: function (fullscreenActive, event) {
      this.Controller.Map.instance.getControlById('fullscreen').ctrlInstance.changeState(fullscreenActive ? 'exit' : 'fullscreen');
    },
  },
  /**
   * enables a control element on the map to display the current map zoom level
   *
   * @method enableZoomLevelDebug
   */
  enableZoomLevelDebug: function(){
    // Update zoom level debug map control on every map change (zoom / pan)
    this.Controller.Map.instance.setOnChange(this.Controller.Map.setZoomLevelDebugValue.bind(this));
    // initially update zoom level debug map control
    Hafas.bind(this.Controller.Map.setZoomLevelDebugValue,this)();
  },
  /**
   * updates zoom level debug map control element with new current zoom level
   *
   * @method setZoomLevelDebugValue
   */
  setZoomLevelDebugValue: function(){
    Hafas('#HFS_ZoomLevelControl',false).innerHTML = parseInt(this.Controller.Map.instance.getZoom("api"), 10);
  },
  cleanup: function () {
    /*console.log("---------------------------------");
     console.log("CLEAN UP MAP CONTROLLER CALLED...");
     console.log("---------------------------------");*/
  },
  /**
   * Initialize the map layers based on the show attribute of the baseLayer.
   * Implemented to work with Leaflet.
   * @method initLayer
   */
  initLayer: function() {
    if (Hafas.Util.checkPath(this, "Controller.Map.instance") === false) {
      Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "Controller.Map.initLayer", "Missing Map.instance");
    }

    if (this.Controller.Map.instance.isLayerInitialized === true) {
      // Skip if we have done that before
      return;
    }

    if (Hafas.Util.checkPath(this, "Controller.Map.instance.mapParams.baseLayer") === false) {
      Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "Controller.Map.initLayer", "Missing Map.instance.mapParams.baseLayer");
    }

    // Run through baseLayers from (server) config and find the ones to be displayed
    var layersToShow = [];
    for (var b = 0; b < this.Controller.Map.instance.mapParams.baseLayer.length; b++) {
      var layer = this.Controller.Map.instance.mapParams.baseLayer[b];
      if (layer.show === true) {
        layersToShow.push(layer);
      }
    }

    if (Hafas.Util.checkPath(this, "Controller.Map.instance.baseMaps") === false) {
      Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "Controller.Map.initLayer", "Missing Map.instance.baseMaps");
    }

    // Run through the selected layers and add the baseMap layers (Leaflet objects) to the map. Mark that we initialized a layer
    for (var l = 0; l < layersToShow.length; l++) {
      var layerId = layersToShow[l].id;
      var baseMap = this.Controller.Map.instance.baseMaps[layerId];
      if (baseMap !== undefined) {
        this.Controller.Map.instance.map.addLayer(baseMap);

        // Set flag that a layer has been initialized
        this.Controller.Map.instance.isLayerInitialized = true;
      }
    }
  },
  /**
   * Fired when Layout changed from mobile to desktop view
   * Calls initLayer function to ensure that the base layers will be initialized
   *
   * @param {string} layoutClass - The new layout class the webapp has switched to
   */
  observeLayoutChangeMobileToDesktop: function(layoutClass) {
    // We only need to re-init the layers if the layout changes from small to any other layout‚‚
    Hafas.bind(this.Controller.Map.initLayer, this)();
  },
  /**
   * Show the map base layer matching the given color scheme.
   * @param {string} colorScheme - The color scheme which the base layer should have
   */
  showBaseLayerByColorScheme: function (colorScheme) {
    if (this.Controller.Map.instance) {
      this.Controller.Map.instance.showBaseLayerByColorScheme(colorScheme);
    }
  },
  sideDrawerTooltipRender: function (){
    var sideDrawerContent = Hafas('#HFS_PageSideDrawer .lyr_sideDrawerContent .lyr_sideDrawItem', false);
    for(var c = 0 ; c < sideDrawerContent.length ; c++){
      var sideDrawItems = Hafas('.lyr_optionItem:not(.lyr_optionItemStatic)', true, sideDrawerContent[c]);
      for(var i = 0 ; i < sideDrawItems.length ; i++){
        var zoomHint = Hafas('span[data-zoom-hint]', false, sideDrawItems[i]);
        if(zoomHint && !zoomHint.hidden){
            var zoomHintWrap = zoomHint.closest('.lyr_optionItem');
            if(zoomHintWrap){
              zoomHintWrap.classList.add('lyr_onboardingTooltipWrapper');
            }
            break;
          }
      }
    }
  }
};
